/**
 * The header's "Last updated on" stamp and the number on the notification bell.
 *
 * SAMPLE VALUES. No orchestrator feed or notifications service exists yet; the bell is
 * presentational (ShellHeader). The Agent Hub's own briefing and insights moved to the
 * agenthub-overview app and its API; only these two header values stay in the shell,
 * because the header is the shell's. Replace with a real source when one exists.
 */
export const HEADER_STATUS = {
  lastUpdated: '10 Sep 2026 15:12:00',
  notificationCount: 9,
} as const;
